import { parseUnits, formatUnits } from "viem";

export type SUPPORTED_BOT_CHAIN_IDS = 1 | 6517303 | number;

export const formatNativeCurrency = (
  value: string,
  chainId: SUPPORTED_BOT_CHAIN_IDS
) => {
  try {
    return parseUnits(value, chainId === 6517303 ? 9 : 18).toString();
  } catch {
    return "";
  }
};

export const formatTokenCurrency = (value: string, decimals: number) => {
  return parseUnits(value, decimals).toString();
};

export const formatNativeAmountForDisplay = (
  value: string,
  chainId: SUPPORTED_BOT_CHAIN_IDS
) => {
  return formatUnits(BigInt(value), chainId === 6517303 ? 9 : 18).toString();
};

export const formatTokenAmountForDisplay = (
  value: string,
  decimals: number
) => {
  return formatUnits(BigInt(value), decimals).toString();
};

export const formatDecimalStringFloat = (
  value: string,
  limit = true,
  allowNegative = true,
  decimals = 2
) => {
  if (value === "") return "";

  const sanitized = value.replace(",", ".").trim();

  if (sanitized === "-") return allowNegative ? sanitized : "";

  if (sanitized === "-.") return "";

  const lastChar = sanitized.slice(-1);

  if (lastChar !== "." && lastChar !== "-" && isNaN(Number(sanitized))) {
    return "";
  }

  if (lastChar === ".") {
    const dotCount = (sanitized.match(/\./g) || []).length;

    if (dotCount > 1) {
      return sanitized.slice(0, -1);
    }
  }

  if (lastChar === "-") {
    const minusCount = (sanitized.match(/-/g) || []).length;

    if (minusCount > 1 || sanitized.length > 1) {
      return sanitized.slice(0, -1);
    }
  }

  if (/^-?\d*\.$/.test(sanitized)) {
    return sanitized;
  }

  if (limit && sanitized.includes(".")) {
    const [, decimalPart] = sanitized.split(".");
    if (decimalPart && decimalPart.length > decimals) {
      return sanitized.slice(0, sanitized.length - 1);
    }
  }

  return sanitized;
};

export function formatToDecimals(value: number, decimals = 2): string {
  return parseFloat(value.toFixed(decimals)).toString();
}
